// components/InvoiceTypeSelector.jsx
import { Form, Radio, Row, Col } from 'antd';
import React from 'react';

const InvoiceTypeSelector = ({ invoiceType, setInvoiceType }) => {
  const handleInvoiceTypeChange = (e) => {
    setInvoiceType(e.target.value);
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Form.Item
          name="invoiceType"
          label="Tipo de Factura"
          initialValue={invoiceType}
        >
          <Radio.Group onChange={handleInvoiceTypeChange}>
            <Radio.Button value={1}>IVA Compras</Radio.Button>
            <Radio.Button value={2}>IVA Ventas</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default InvoiceTypeSelector;